export default __webpack_public_path__ + "static/media/spotify.85b0454a.svg";